setTimeout(function(){
    $(document).ready(function() {
    	if ($("html").attr("data-bank") == "ALEX") {
        	var interval;
            var count = 0;
            interval = setInterval(anni, 100);
    	}
    });
},100);

anni= function() {
	 $('.datepicker-grid.rtl').find('.year.selectable,.year.curYear.selectable.focus,.datepicker-month').click(function(){
     	console.log("change in ar year dx");
     	if($("html").attr("lang") == "ar-EG"){ 
     	setTimeout(function(){
         	$('.datepicker-month').find('span').each(function(i, v) {
		        	var arabicNumbers = ['۰', '۱', '۲', '۳', '٤','٥','٦', '۷', '۸', '۹'];
		        	if($(v)[0] != undefined){
			        	for(var cou = 0; cou < $(v)[0].childNodes.length; cou ++){
			        		var chars = $(v)[0].childNodes[cou].textContent.split('');
				            for (var i = 0; i < chars.length; i++) {
				                if (parseFloat(chars[i]) > -1) {
				                	chars[i] = arabicNumbers[chars[i]];
				                }
				            }
				            $(v)[0].childNodes[cou].textContent = chars.join('');
			        	}
		        	}
	//            				            var charsJoined = chars.join('');
	//            				        	return charsJoined;
		        });
     	},100);
     	 }
     });
}


setTimeout(function(){
    $(document).ready(function() {
    	if ($("html").attr("data-bank") == "ALEX") {
        	var interval;
            var count = 0;
            interval = setInterval(mesi, 100);
    	}
    });
},100);


mesi= function() {
    $('.datepicker-calendar').find('.month.selectable,.month.selectable.focus').click(function(){
    	console.log("change in ar calendar");
    	if($("html").attr("lang") == "ar-EG"){ 
    		setTimeout(function(){
    			$('.birth-alex-calendar').find('.day.selectable,.day.unselectable,.empty,.datepicker-month,.populateYears,.year.selectable,.year.curYear.selectable.focus,.only-year-selection').each(function(i, v) {
		        	var arabicNumbers = ['۰', '۱', '۲', '۳', '٤','٥','٦', '۷', '۸', '۹'];
		        	if($(v)[0] != undefined){
			        	for(var cou = 0; cou < $(v)[0].childNodes.length; cou ++){
			        		var chars = $(v)[0].childNodes[cou].textContent.split('');
				            for (var i = 0; i < chars.length; i++) {
				                if (parseFloat(chars[i]) > -1) {
				                	chars[i] = arabicNumbers[chars[i]];
				                }
				            }
				            $(v)[0].childNodes[cou].textContent = chars.join('');
			        	}
		        	}
//		            var charsJoined = chars.join('');
//		        	return charsJoined;
		        });
    		},100);
    	 }
    });
}


setTimeout(function(){
    $(document).ready(function() {
    	if ($("html").attr("data-bank") == "ALEX") {
        	var interval;
            var count = 0;
            interval = setInterval(inizio, 100);
    	}
    });
},100);


inizio= function() {
	$("#IDdatePickerBirthDay").change(function(){
		if($("html").attr("lang") == "ar-EG"){ 
			setTimeout(function(){
		    	var arabicNumbers = ['۰', '۱', '۲', '۳', '٤','٥','٦', '۷', '۸', '۹'];
		    	var chars = $("#IDdatePickerBirthDay").val().split('');
		        for (var i = 0; i < chars.length; i++) {
		            if (parseFloat(chars[i]) > -1) {
		            	chars[i] = arabicNumbers[chars[i]];
		            }
		        }
			    var charsJoined = chars.join('');
				$("#IDdatePickerBirthDay").val(charsJoined);
			},100);
		}
	});
}

$(document).ready(function() {
setTimeout(function(){
	if ($("html").attr("data-bank") == "ALEX") {
		$(".datepicker-button").on('click',function(){
			console.log("clear input");
			if($("#IDdatePickerBirthDay").val() != undefined || $("#IDdatePickerBirthDay").val() != ""){
				$("#IDdatePickerBirthDay").val("");
			}
		});
	}
},1000);
});
//setTimeout(function(){
//    $(document).ready(function() {
//    	if ($("html").attr("data-bank") == "ALEX") {
//        	var interval;
//            var count = 0;
//            interval = setInterval(inizioB, 100);
//    	}
//    });
//},100);
//
//
//inizioB= function() {
//	$(".datepicker-button").click(function(){
//    	console.log("change in ar la data");
//		if($("html").attr("lang") == "ar-EG"){ 
//			setTimeout(function(){
//		    	var arabicNumbers = ['۰', '۱', '۲', '۳', '٤','٥','٦', '۷', '۸', '۹'];
//		    	var chars = $("#IDdatePickerBirthDay").val().split('');
//		        for (var i = 0; i < chars.length; i++) {
//		            if (parseFloat(chars[i]) > -1) {
//		            	chars[i] = arabicNumbers[chars[i]];
//		            }
//		        }
//			    var charsJoined = chars.join('');
//				console.log(charsJoined)
//				$("#IDdatePickerBirthDay").val(charsJoined);
//			},100);
//		}
//	});
//}



